module.exports = __webpack_public_path__ + "img/ico-start.d1c1f699.svg";